import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=1f6a4d93&scoped=true"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=1f6a4d93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a4d93",
  null
  
)

export default component.exports